import { Action, ActionNames } from '../actions';
import { Review } from '../store';

const defaultReview =  {
    comment: '',
    pictureUrls: [],
    thumbnailUrls: [],
    rating: 0,
    requestId: null,
    readOnly: false,
    createdOnUtc: null,
    author: null,
    orderId: 0,
    orderPictureUrls: []
};

const fetchedReview = (state: Review = defaultReview,  action: Action) => {
    if (action.type === ActionNames.ReviewActions.fetchResult) {
        return action.review;
    }

    if (action.type === ActionNames.ReviewActions.rate) {
        return { ...state, rating: action.rate };
    }

    if (action.type === ActionNames.ReviewActions.comment) {
        return { ...state, comment: action.text };
    }

    if (action.type === ActionNames.ReviewActions.author) {
        return { ...state, author: action.text };
    }

    return state;
};

export default fetchedReview;
